import { createContext, useContext, useState } from "react";

const TestModeContext = createContext();

export const TestModeContextProvider = ({ children }) => {
  const [testTime, setTestTime] = useState(15);
  const [testMode, setTestMode] = useState("time"); // time, zen
  const [suddenDeath, setSuddenDeath] = useState(false);

  const values = {
    testTime,
    setTestTime,
    testMode,
    setTestMode,
    suddenDeath,
    setSuddenDeath,
  };

  return (
    <TestModeContext.Provider value={values}>
      {children}
    </TestModeContext.Provider>
  );
};

export const useTestMode = () => useContext(TestModeContext);
